<script setup lang="ts">
/**
 * Badge de statut d'un objet matériel : icône Heroicon outline + couleur + label
 * (jamais la couleur seule, cf. MASTER §1). Réutilisé en liste et en détail.
 */
import { computed } from 'vue'
import {
  ArrowPathIcon,
  ArrowUturnLeftIcon,
  CheckCircleIcon,
  ClipboardDocumentListIcon,
  InboxArrowDownIcon,
  ShoppingCartIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/vue/24/outline'
import { ASSET_STATUS_META } from '@/v2/onboarding/catalog'
import type { AssetStatus } from '@/v2/onboarding/types'

const props = defineProps<{ status: AssetStatus; size?: 'sm' | 'md' }>()

const ICONS = {
  ClipboardDocumentList: ClipboardDocumentListIcon,
  ShoppingCart: ShoppingCartIcon,
  InboxArrowDown: InboxArrowDownIcon,
  WrenchScrewdriver: WrenchScrewdriverIcon,
  CheckCircle: CheckCircleIcon,
  ArrowUturnLeft: ArrowUturnLeftIcon,
  ArrowPath: ArrowPathIcon,
} as const

const meta = computed(() => ASSET_STATUS_META[props.status])
const icon = computed(() => ICONS[meta.value.icon as keyof typeof ICONS])
const iconSize = computed(() => (props.size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5'))
</script>

<template>
  <span :class="['badge gap-1', meta.badgeClass, size === 'md' ? 'badge-md' : 'badge-sm']">
    <component :is="icon" :class="iconSize" aria-hidden="true" />
    <span>{{ meta.label }}</span>
  </span>
</template>
